export const LAST_EDITED_ID = 'lastEditedId';
